







































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';

type Rule = (value: string) => boolean | string;

@Component({})
export default class InputField extends Vue {
  @PropSync('value', { required: false, type: String, default: '' })
  valueSynced!: string;
  @Prop(String)
  placeholder!: string;
  @Prop(String)
  type!: string;
  @Prop(Boolean)
  disabled!: boolean;
  @Prop({ default: () => [], required: false, type: Array as () => Rule[] })
  rules!: Rule[];
  @Prop(Boolean)
  hasError!: boolean;
  @Prop(Number)
  maxLength!: number;

  currentInput = '';

  mounted() {
    this.currentInput = this.valueSynced;
  }

  checkRules(value: any): boolean {
    return this.rules?.some(rule => {
      return !(rule(value) === true);
    });
  }

  get hasViolatedRules(): boolean {
    return this.checkRules(this.currentInput);
  }

  get currentLength() {
    return this.valueSynced?.length ?? 0;
  }

  valueChanged(value: any) {
    this.currentInput = value;
    if (this.checkRules(value)) {
      return;
    }
    this.$emit('change', value);
  }

  submit(event: any) {
    this.currentInput = event.target.value;
    if (this.checkRules(event.target.value)) {
      return;
    }
    this.$emit('submit', event.target.value);
  }
}
